import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Tooltip } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { object, func, bool } from 'prop-types'
import { styled as transientStyled } from '@utils/styleHelpers'

const StyledLoading = styled.div`
  padding: calc(50% - 20px);
  background-color: lightgray;
`

const StyledItem = transientStyled(Paper)(
  ({ theme, isSelected, isHovered, transform, isSelection }) => css`
    box-sizing: border-box;
    flex: 0 0 20%;
    flex-shrink: 0;
    transition:
      transform 300ms ease 100ms,
      box-shadow 300ms ease 100ms;
    margin: 0 2px;
    position: relative;
    padding: 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;

    img {
      width: 75px;
      max-width: 75px;
      vertical-align: top;
    }

    cursor: pointer;

    border-radius: 4px;
    border: 3px solid;
    border-color: ${isSelected ? theme.palette.secondary.main : 'transparent'};

    transform: ${(isSelection ? isSelected : isHovered)
      ? 'scale(1.2)'
      : `translateX(${transform === 'before' ? '-10' : transform === 'after' ? '10' : '0'}%)`};
  `,
)

export const Item = ({
  item,
  selected = false,
  hovered = null,
  onMouseEnter,
  onMouseLeave,
  onClick,
  isSelection = false,
  disabled,
  disabledMessage,
}) => {
  const title = disabled ? disabledMessage : ''
  return (
    <Tooltip title={title} placement="top">
      <StyledItem
        isSelection={isSelection}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={() => !item.loading && onClick()}
        transform={item.direction || 'none'}
        isSelected={selected}
        isHovered={hovered}
      >
        {!item.loading && (
          <>
            <img
              src={`https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/${item.slug}.png`}
              alt={item.slug}
            />
            <div style={{ textAlign: 'center', marginTop: 12, marginLeft: -12, marginRight: -12 }}>
              <Typography style={{ display: 'inline-block' }} variant="h6">
                {item.name}
              </Typography>
            </div>
          </>
        )}
        {item.loading && (
          <StyledLoading>
            <CircularProgress />
          </StyledLoading>
        )}
      </StyledItem>
    </Tooltip>
  )
}

Item.propTypes = {
  selected: bool,
  hovered: bool,
  item: object.isRequired,
  onMouseEnter: func.isRequired,
  onMouseLeave: func.isRequired,
  onClick: func.isRequired,
  isSelection: bool,
}
